import React, { Component } from 'react';
import config from 'react-global-configuration';
import getLocale from '../../../i18n/getLocale';
import RequestApi from '../../Miscelania/RequestApi';

class TrainingLogbooksTabAddFile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: false,
      id: this.props.id,
      file_archived: this.props.file_archived,
      file: this.props.file,
    };

    this.locale = getLocale();

    //bind específico
    this.addFile = this.addFile.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(typeof newProps.id !== 'undefined') {
      this.setState({
        id: newProps.id,
        file_archived: newProps.file_archived,
        file: newProps.file,
      });
    }
  }

  addFile(event) {
    event.preventDefault();
    var confirm = window.confirm(this.locale.Treinamentos.EditarTreinamento.tabLogbook.tabelaListaDeSessoes.ImportarArquivo);
    if (confirm) {
      var data = new FormData();
      var imagedata = document.querySelector('.input-archive-logbooks-' + this.state.id).files[0];
      data.append("imagem", imagedata);
      data.append("id", this.state.id);
      var header = this.refs.request_api.header();
      var self = this;
      this.props.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/treinamento/certificado/logbook/arquivo', {
          method: 'POST',
          mode: 'cors',
          headers: value,
          body: data }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.props.updateData(responseJson);
          }).catch((error) => {
          console.error(error);
        });
      });
    }
  }


  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
    <form onSubmit={this.addFile}>
        <input type="file" name="archive" className={"form-control input-display-inline input-archive-logbooks-" + this.state.id} placeholder={this.locale.Treinamentos.EditarTreinamento.tabLogbook.tabelaListaDeSessoes.formularioListaDeSessoes.placeholder.Arquivo} value={this.state.archive} onChange={this.handleChange.bind(this, 'archive')} style={{width: 135}} required />
        <button type="submit" className="btn btn-primary btn-sm btn-margin-bottom btn-margin-left"><i className="fa fa-save"></i></button>
        &nbsp;
        <a className={"btn btn-sm btn-warning btn-margin-bottom"} disabled={this.state.file_archived === 1 ? "" : "disabled"} target="_blank" href={config.get('cdn') + '/files/logbooks/' + this.state.file}><i className="fa fa-fw fa-download"></i>
        </a>
        &nbsp;
    </form>
</div>
    );
  }
}

export default TrainingLogbooksTabAddFile;



// WEBPACK FOOTER //
// ./src/Components/Trainings/Elements/TrainingLogbooksTabAddFile.js